import React, { useState } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

const IconFactory = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 20h20" /><path d="M9 20V10l-5 5V7l7-5 7 5v8l-5-5v10" />
  </svg>
)

const IconFile = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><line x1="10" y1="9" x2="8" y2="9" />
  </svg>
)

const TABS = [
  {
    key: "industries",
    Icon: IconFactory,
    title: "Industries",
    desc: "Sectors we specialise in serving",
    bg: "#eff6ff",
    ic: "#1b2d8e",
    centerLabel: "Industries We Serve",
    // Real routes to the pages built in the industries rebuild
    // (src/docs/visiomate-industries-rebuild-brief.md, Batches 2-4). Travel is
    // dropped per the brief (no offer, no client proof). Education and
    // Construction & Engineering are held back — each needs a decision
    // (an unverified proof client; a no-proof framing) before it gets a page —
    // so neither appears here yet rather than linking to something that
    // doesn't exist. Add them once built.
    links: [
      { to: "/industries/manufacturing", label: "Manufacturing" },
      { to: "/industries/retail", label: "Retail" },
      { to: "/industries/distribution", label: "Distribution" },
      { to: "/industries/healthcare", label: "Healthcare" },
      { to: "/industries/events-production", label: "Events & Production" },
      { to: "/industries/field-service", label: "Field Service" },
      { to: "/industries/real-estate", label: "Real Estate" },
    ],
  },
]

// Case Studies is a direct link now, not a switchable tab with its own
// panel of individual stories — /caseStudies lists all of them instead.
// Same icon/colours as before, so the nav item looks unchanged.
const CASE_STUDIES_LINK = {
  Icon: IconFile,
  title: "Case Studies",
  desc: "Real-world project success stories",
  bg: "#fff7ed",
  ic: "#ea580c",
  to: "/caseStudies",
}

const OurPrimaryFocus = ({ queryData }) => {
  const [active, setActive] = useState("industries")

  return (
    <div className="mega-menu">
      {/* Left: focus area tabs */}
      <div className="mega-menu__left">
        <p className="mega-menu__section-label">Focus Areas</p>
        {TABS.map(({ key, Icon, title, desc, bg, ic }) => (
          <button
            key={key}
            className={`mega-menu__nav-item${active === key ? " is-active" : ""}`}
            onClick={() => setActive(key)}
          >
            <div className="mega-menu__nav-icon" aria-hidden="true" style={{ background: bg }}>
              <Icon style={{ color: ic }} />
            </div>
            <div className="mega-menu__nav-text">
              <strong>{title}</strong>
              <span>{desc}</span>
            </div>
          </button>
        ))}
        <Link to={CASE_STUDIES_LINK.to} className="mega-menu__nav-item">
          <div className="mega-menu__nav-icon" aria-hidden="true" style={{ background: CASE_STUDIES_LINK.bg }}>
            <CASE_STUDIES_LINK.Icon style={{ color: CASE_STUDIES_LINK.ic }} />
          </div>
          <div className="mega-menu__nav-text">
            <strong>{CASE_STUDIES_LINK.title}</strong>
            <span>{CASE_STUDIES_LINK.desc}</span>
          </div>
        </Link>
      </div>

      {/* Center: the Industries panel. Case Studies has no panel of its own
          any more — it's the direct link above. */}
      <div className="mega-menu__center">
        {TABS.map(t => (
          <div
            key={t.key}
            className={`mega-menu__tabpanel${active === t.key ? " is-active" : ""}`}
          >
            <p className="mega-menu__section-label">{t.centerLabel}</p>
            <div className="mega-menu__grid">
              {t.links.map(({ to, label }) =>
                to ? (
                  <Link key={label} to={to} className="mega-menu__link">
                    <div className="mega-menu__link-icon" aria-hidden="true" style={{ background: t.bg, color: t.ic }}>→</div>
                    {label}
                  </Link>
                ) : (
                  <div key={label} className="mega-menu__link" style={{ cursor: "default" }}>
                    <div className="mega-menu__link-icon" aria-hidden="true" style={{ background: t.bg, color: t.ic }}>→</div>
                    {label}
                  </div>
                )
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Right: What's Latest */}
      <div className="mega-menu__right">
        <p className="mega-menu__section-label">What's Latest</p>
        <div className="mega-menu__featured-img">
          <Img fluid={queryData.perimflowForMenu.childImageSharp.fluid} alt="PerimFlow" />
        </div>
        <p className="mega-menu__featured-desc">
          PerimFlow – a fencing automation solution simplifying project management, quoting, and operations for fencing contractors.
        </p>
        <a href="https://perimflow.com/" target="_blank" rel="noopener noreferrer" className="mega-menu__cta-link">Visit PerimFlow →</a>
      </div>
    </div>
  )
}

export default OurPrimaryFocus
